export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'left',
    width: 80,
    showHeaderOverflow: true,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_displayImage') || '图片',
    field: 'displayImage',
    width: 80,
    align: 'center',
    fixed: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_displayProductName') || '产品名称',
    field: 'displayProductName',
    minWidth: 250,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayProductName' },
  },
  {
    title: that.$l('table_label_displayProductUnit') || '产品单位入数',
    field: 'displayProductUnit',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayProductUnit' },
  },
  {
    title: that.$l('table_label_unitInCtnQty') || '装箱入数',
    field: 'unitInCtnQty',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    isTotalColumn: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 0,
        min: 0,
        max: 500,
        controls: false,
        size: 'mini',
        style: 'width:100%',
      },
    },
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_specInCtnQty') || '入箱规格数量',
    field: 'specInCtnQty',
    minWidth: 120,
    align: 'center',
    isTotalColumn: true,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
]
